import {
    ChangeDetectionStrategy,
    Component,
    computed,
    DestroyRef,
    effect,
    ElementRef,
    inject,
    input,
    OnDestroy,
    output,
    resource,
    signal,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Item } from "../../pojo/Item";
import { ContextMenuService } from "./context.menu.service";

@TypeManagerDecorator("s25-ng-context-menu")
@Component({
    selector: "s25-ng-context-menu",
    template: `
        @if (contextBean() && lang() && !closed()) {
            <div class="ngContextMenu b-contextmenu" id="S25Object_ContextMenu_{{ objectMap[itemTypeId()] }}">
                <table>
                    <tbody>
                        <tr id="S25Object_ContextMenu_{{ objectMap[itemTypeId()] }}_Header" class="b-contextmenurow">
                            <td class="ngContextMenuRow b-contextmenu-label-expand">
                                {{ lang().header }}
                            </td>
                        </tr>
                        @if (itemTypeId() === Item.AvailabilityItemTypeId) {
                            <!-- Special cases for s25.availability.grid -->
                            @let availGridBean = $any(contextBean());
                            <tr class="b-contextmenurow">
                                <td
                                    class="c-contextmenu-label-expand ngCpointer"
                                    (click)="availGridBean.deleteRsrv()"
                                    (keydown.enter)="availGridBean.deleteRsrv()"
                                    [attr.disabled]="!availGridBean.perms.canDelete"
                                    tabindex="0"
                                >
                                    Occurrence Delete
                                </td>
                            </tr>
                            <tr class="b-contextmenurow">
                                <td
                                    class="b-contextmenu-label-expand ngCpointer"
                                    (click)="availGridBean.copyRsrv()"
                                    (keydown.enter)="availGridBean.copyRsrv()"
                                    [attr.disabled]="!availGridBean.perms.canCopy"
                                    tabindex="0"
                                >
                                    Occurrence Copy
                                </td>
                            </tr>
                            <tr class="b-contextmenurow">
                                <td
                                    class="b-contextmenu-label-expand ngCpointer"
                                    (click)="availGridBean.rsrvDetails()"
                                    (keydown.enter)="availGridBean.rsrvDetails()"
                                    tabindex="0"
                                >
                                    Occurrence Copy
                                </td>
                            </tr>
                        }
                        @if (contextBean().subPerms.hasOpenInNewTab) {
                            <tr class="b-contextmenurow">
                                <td class="b-contextmenu-label-expand ngCpointer">
                                    <a
                                        class="ngUnstyledAnchor ngWidth100 ngInlineBlock"
                                        href="{{ contextBean().itemUrl }}"
                                        target="_blank"
                                        rel="noopener"
                                        >Open in New Tab</a
                                    >
                                </td>
                            </tr>
                        }
                        <tr class="b-contextmenurow">
                            <td
                                class="b-contextmenu-label-expand ngCpointer"
                                (click)="contextBean().details()"
                                (keydown.enter)="contextBean().details()"
                                tabindex="0"
                            >
                                {{ lang().details }}
                            </td>
                        </tr>
                        @if (itemTypeId() === Item.Ids.Event) {
                            <tr class="b-contextmenurow">
                                <td
                                    class="b-contextmenu-label-expand ngCpointer"
                                    (click)="contextBean().calendar()"
                                    (keydown.enter)="contextBean().calendar()"
                                    tabindex="0"
                                >
                                    {{ lang().calendar }}
                                </td>
                            </tr>
                            @if (contextBean().subPerms.hasEditEvent) {
                                <tr id="S25Object_ContextMenuRow_EventEdit" class="b-contextmenurow">
                                    <td
                                        class="b-contextmenu-label-expand ngCpointer"
                                        (click)="contextBean().editEvent()"
                                        (keydown.enter)="contextBean().editEvent()"
                                        tabindex="0"
                                    >
                                        {{ lang().edit_event }}
                                    </td>
                                </tr>
                            }
                            @if (contextBean().subPerms.hasCopyEvent) {
                                <tr id="S25Object_ContextMenuRow_EventClone" class="b-contextmenurow">
                                    <td
                                        class="b-contextmenu-label-expand ngCpointer"
                                        (click)="contextBean().copyEvent()"
                                        (keydown.enter)="contextBean().copyEvent()"
                                        tabindex="0"
                                    >
                                        {{ lang().copy_event }}
                                    </td>
                                </tr>
                            }
                            @if (contextBean().subPerms.hasEmail) {
                                <tr id="S25Object_ContextMenuRow_EmailEventDetails" class="b-contextmenurow">
                                    <td
                                        class="b-contextmenu-label-expand ngCpointer"
                                        (click)="contextBean().emailEvent()"
                                        (keydown.enter)="contextBean().emailEvent()"
                                        tabindex="0"
                                    >
                                        {{ lang().email_event }}
                                    </td>
                                </tr>
                            }
                        } @else {
                            <tr class="b-contextmenurow">
                                <td
                                    class="b-contextmenu-label-expand ngCpointer"
                                    (click)="contextBean().list()"
                                    (keydown.enter)="contextBean().list()"
                                    tabindex="0"
                                >
                                    {{ lang().list }}
                                </td>
                            </tr>
                            @if (itemTypeId() === Item.Ids.Location || itemTypeId() === Item.Ids.Resource) {
                                <tr class="b-contextmenurow">
                                    <td
                                        class="b-contextmenu-label-expand ngCpointer"
                                        (click)="contextBean().availability()"
                                        (keydown.enter)="contextBean().availability()"
                                        tabindex="0"
                                    >
                                        {{ lang().availability }}
                                    </td>
                                </tr>
                            }

                            @if (itemTypeId() === Item.Ids.Location) {
                                <tr class="b-contextmenurow">
                                    <td
                                        class="b-contextmenu-label-expand ngCpointer"
                                        (click)="contextBean().availabilityWeekly()"
                                        (keydown.enter)="contextBean().availabilityWeekly()"
                                        tabindex="0"
                                    >
                                        {{ lang().availability_weekly }}
                                    </td>
                                </tr>
                            }
                            <tr class="b-contextmenurow">
                                <td
                                    class="b-contextmenu-label-expand ngCpointer"
                                    (click)="contextBean().calendar()"
                                    (keydown.enter)="contextBean().calendar()"
                                    tabindex="0"
                                >
                                    {{ lang().calendar }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    `,
    styles: `
        :host ::ng-deep .b-contextmenu {
            top: unset;
            left: unset;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: {
        "(document:click)": "catchOutsideClick($event)",
        "(document:contextmenu)": "catchOutsideClick($event)",
        "(document:keydown.escape)": "close()",
    },
})
export class S25ContextMenuComponent implements OnDestroy {
    readonly itemTypeId = input.required<Item.Id | typeof Item.AvailabilityItemTypeId>();
    readonly itemId = input.required<number>();
    readonly bean = input<any>(undefined);

    readonly closedOutput = output<void>({ alias: "closed" });

    readonly modelBeanRq = resource({
        params: () => ({ itemTypeId: this.itemTypeId(), itemId: this.itemId(), bean: this.bean() }),
        loader: ({ params }) => ContextMenuService.hydrateMenu(params.itemTypeId, params.itemId, params.bean),
    });

    private readonly elementRef = inject(ElementRef);
    private readonly destroyRef = inject(DestroyRef);

    readonly contextBean = computed(() => (this.modelBeanRq.hasValue() ? this.modelBeanRq.value().data : undefined));
    readonly lang = computed(() => this.contextBean()?.lang.div.controls.application.text.contextmenu);
    readonly closed = signal(false);

    readonly objectMap: { readonly [key: number]: "Event" | "Space" | "Resource" | "Organization" | "Contact" } = {
        [Item.Ids.Event]: "Event",
        [Item.AvailabilityItemTypeId]: "Event",
        [Item.Ids.Organization]: "Organization",
        [Item.Ids.Contact]: "Contact",
        [Item.Ids.Location]: "Space",
        [Item.Ids.Resource]: "Resource",
    } as const;

    constructor() {
        ContextMenuService.registerInstance(this);
        effect(() => {
            if (this.closed() && !this.destroyRef.destroyed) {
                this.closedOutput.emit();
            }
        });
    }

    ngOnDestroy() {
        if (!this.closed()) {
            this.closed.set(true);
            this.closedOutput.emit();
        }
        ContextMenuService.unregisterInstance(this);
    }

    close() {
        this.closed.set(true);
    }

    catchOutsideClick($event: MouseEvent) {
        if (!this.elementRef.nativeElement.contains($event.target)) {
            this.close();
        }
    }

    protected readonly Item = Item;
}
